"use strict";

exports.__esModule = true;
exports.default = createIndexFinder;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _setup = require("./_setup.js");
var _isNaN = _interopRequireDefault(require("./isNaN.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal function to generate the `_.indexOf` and `_.lastIndexOf` functions.
function createIndexFinder(dir, predicateFind, sortedIndex) {
  return function (array, item, idx) {
    var i = 0,
      length = (0, _getLength.default)(array);
    if (typeof idx == 'number') {
      if (dir > 0) {
        i = idx >= 0 ? idx : Math.max(idx + length, i);
      } else {
        length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
      }
    } else if (sortedIndex && idx && length) {
      idx = sortedIndex(array, item);
      return array[idx] === item ? idx : -1;
    }
    if (item !== item) {
      idx = predicateFind(_setup.slice.call(array, i, length), _isNaN.default);
      return idx >= 0 ? idx + i : -1;
    }
    for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
      if (array[idx] === item) return idx;
    }
    return -1;
  };
}